import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  UPDATE: 'update',
}

class Gyro {
  constructor(el) {
    Object.assign(this, EventEmitter, {
      x: 0,
      y: 0,
      z: 0,
      rotation: {
        alpha: 0,
        beta: 0,
        gamma: 0,
      },
      gravity: true,
      landscape: false,
    })

    this.listen()
  }

  _motion = (event) => {
    const { x, y, z } = this.gravity ? event.accelerationIncludingGravity : event.acceleration
    const { alpha, beta, gamma } = event.rotationRate || null

    this.x = this.landscape ? y : x || -1
    this.y = this.landscape ? x : y || -1
    this.z = z || -1
    this.rotation.alpha = alpha || -1
    this.rotation.beta = beta || -1
    this.rotation.gamma = gamma || -1

    this.emit(Events.UPDATE, {
      x: this.x,
      y: this.y,
      z: this.z,
      alpha: this.rotation.alpha,
      beta: this.rotation.beta,
      gamma: this.rotation.gamma,
    })
  }

  _orientation = (event) => {
    this.landscape = window.innerWidth > window.innerHeight
  }

  listen = () => {
    if (this.listening) return
    this.listening = true
    window.addEventListener('devicemotion', this._motion)
    window.addEventListener('resize', this._orientation)
  }

  unlisten = () => {
    if (!this.listening) return
    this.listening = false
    window.removeEventListener('devicemotion', this._motion)
    window.removeEventListener('resize', this._orientation)
  }
}

let gyro = new Gyro()
gyro.Events = Events
export default gyro
